import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bcf650a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4bcf650a&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4bcf650a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf650a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bcf650a')) {
      api.createRecord('4bcf650a', component.options)
    } else {
      api.reload('4bcf650a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4bcf650a&scoped=true", function () {
      api.rerender('4bcf650a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Boys/PayNext/index.vue"
export default component.exports